module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Bold.88c867682b19bb9b947581649d349f48.woff";